import Dictionary from '@utils/classes/dictionary';

export const GENDER = {
  M: 'male',
  F: 'female',
  O: 'other',
};

export const gender = new Dictionary(GENDER);
